<template>
    <div>
        其他内容待开发
    </div>
</template>
<script>
export default {
    name: "otherPage",
    data() {
        return {
            tableData: [],
            multipleSelection: []
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style></style>